<template>
    <div class="container">
        <div class="test-list">
            <div class="record-item">
                <div class="record-head">
                    <div class="service-name">大五人格</div>
                    <div class="check-result" @click="testStart(92)">开始测评</div>
                </div>
                <div class="record-info">接下来会有一些描述情感、态度和行为的句子。请仔细阅读每个句子，根据与你自身实际情况相符合的程度继续选择。所有回答没有对错好坏之分，因此请不带任何负担地进行选择。</div>
            </div>
            <div class="record-item">
                <div class="record-head">
                    <div class="service-name">PHQ-9</div>
                    <div class="check-result" @click="testStart(119)">开始测评</div>
                </div>
                <div class="record-info">测量您最近的抑郁状态</div>
            </div>
            <div class="record-item">
                <div class="record-head">
                    <div class="service-name">状态焦虑量表</div>
                    <div class="check-result" @click="testStart(117)">开始测评</div>
                </div>
                <div class="record-info">测量您最近的焦虑状态</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {
        testStart(id){
            this.$router.push({ path: '/test-main', query: { id: id}})
        }
    },
    created() {},
};
</script>
<style lang='less' scoped>
.container{
    padding: 16px;
}
.record-item{
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 10px;
}
.record-head{
    height: 56px;
    padding: 0px 12px;
    border-radius: 10px 10px 0px 0px;
    background-color: #FBFCFC;
    display: flex;
    justify-content: space-between;
}
.service-name{
    height: 56px;
    line-height: 56px;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.check-result{
    height: 32px;
    line-height: 32px;
    margin-top: 12px;
    border-radius: 16px;
    background-color: #01D6D6;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    padding: 0px 12px;
}
.record-info{
    border-radius: 0px 0px 10px 10px;
    padding:12px;
    line-height: 20px;
    font-size: 14px;
    color: #333;
}
</style>